import { Box, Button, Container, Dialog, DialogContent, DialogTitle, Divider, Grid, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import React, { useEffect } from "react";
import Pagination from "react-js-pagination";
import Bottom from "../Bottom";
import { useNavigate } from "react-router-dom";
import LodingData from "../../utils/LodingData";
import api from "../../utils/api_v2";
import DownloadIcon from '@mui/icons-material/Download';
import SearchIcon from '@mui/icons-material/Search';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import tab04 from "../../assets/images/tab_04.png"
import BookmarkIcon from '@mui/icons-material/Bookmark';


const Event = () => {

  const navigate = useNavigate();
  const [eventList, setEventList] = React.useState([]);
  const [eventListParam, setEventListParam] = React.useState({ cusId: localStorage.getItem('userCusID'), pageNum: 0, searchWord: '', });
  const [eventListCount, setEventListCount] = React.useState(0);
  const [eventInfo, setEventInfo]: any = React.useState<Record<string, any>>({});

  const updateEventListParam = (name: any, value: any) => {
    setEventListParam((prev: any) => ({
      ...prev,
      [name]: value,
    }))
  }

  // 모달창
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setTimeout(() => setOpen(true), 100);
  const handleClose = () => setOpen(false);

  let cnt = eventListParam.pageNum * 10;

  let i = 0;
  useEffect(() => {
    getEventList();

    return () => {
      setEventListParam({ cusId: localStorage.getItem('userCusID'), pageNum: 0, searchWord: '', });
    }
  }, []);

  const getEventList = () => {
    LodingData(() => api.post('customer/api/v1/CU_010_001', eventListParam)
      .then(res => {
        setEventList(res.data.eventList);
        setEventListCount(res.data.count);
      })
      .catch(err => {
        console.log(err);
      }))
  }

  // 검색 input 핸들러
  const handleSerachInputChange = (e: any) => {
    updateEventListParam(e.target.name, e.target.value);
  }

  const handleSearchButton = () => {
    if (eventListParam.searchWord.length == 1) {
      alert('두 글자 이상 검색어로 입력주세요.');
      return false;
    }

    eventListParam.pageNum = 0;
    getEventList();
  }

  // input 엔터 시
  const handleActiveEnter = (e: any) => {
    if (e.key == 'Enter') {
      handleSearchButton();
    }
  }


  function handlePageChange(page: number) {
    eventListParam.pageNum = page - 1;
    getEventList();
  }

  // 1개 항목 클릭 시 게시글 번호 받아 글 상세내용 보내기
  const handleSelectRow = (targetRow: any) => {
    LodingData(() => api.post('customer/api/v1/CU_010_002', { eventId: targetRow.id })
      .then(res => {
        setEventInfo(res.data);
      })
      .catch(function (error) {
        console.log(error);
      }));
  }

  // 다운로드 클릭 시
  const handleFileDownload = (eventId: any, fileName: any) => {
    LodingData(() => api.post('customer/api/v1/CU_010_003', { id: eventId }, {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        const type = res.headers['content-type'];
        const blob = new Blob([res.data], { type: type });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      })
      .catch(err => {
        console.log(err);
      }))
  }

  // 이벤트 신청하기
  const handleEventApply = () => {
    if (window.confirm('해당 이벤트를 신청하시겠습니까?')) {
      const sendItems = {
        customerId: localStorage.getItem('userCusID'),
        id: eventInfo.id,
      }

      LodingData(() => api.post('customer/api/v1/CU_010_004', sendItems)
        .then(res => {
          if (res.data.message == 'SUCCESS') {
            alert('이벤트 신청이 완료되었습니다.');
            handleClose();
          } else {
            alert('이미 신청된 이벤트입니다.');
          }
        })
        .catch(err => {
          console.log(err);
        }))
    } else {
      return;
    }
  }

  return (
    <Container className="container">
      <Box sx={img} className='topImg'>
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#8acd83', fontWeight: 900 }}>
              이용안내
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#5ead3d', fontWeight: 500, }} gutterBottom>
              이벤트
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box sx={eventBox} className='event_display'>
        {
          eventList.length <= 0 ? (
            <Box sx={{ textAlign: 'center', mt: 10 }}>
              <CalendarMonthIcon sx={{ fontSize: 50, color: '#999' }} />
              <Typography sx={{ fontSize: 16, color: '#777' }}>
                이벤트가 없습니다.
              </Typography>
            </Box>
          ) : (
            <React.Fragment>
              <Box className="wb_search" sx={{ width: 410 }}>
                <TextField id="outlined-basic" className='wb_searchinput' variant="outlined" name="searchWord" value={eventListParam.searchWord} onChange={handleSerachInputChange} onKeyDown={handleActiveEnter} placeholder='제목으로 검색하세요.' size='small' />
                <Button className='search_icon' variant="contained" onClick={handleSearchButton} startIcon={<SearchIcon />}></Button>
              </Box>
              <TableContainer>
                <Table size="small" className="Cl_table" sx={{ mt: 2 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>NO</TableCell>
                      <TableCell>제목</TableCell>
                      <TableCell>작성자</TableCell>
                      <TableCell>작성일</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      eventList && eventList.map((item: any, idx: any) => (
                        <TableRow key={cnt} hover={true} onClick={() => { handleSelectRow(item); handleOpen(); }}>
                          <TableCell width={50}>{cnt += 1}</TableCell>
                          <TableCell>{item.title}</TableCell>
                          <TableCell width={120}>{item.author}</TableCell>
                          <TableCell width={120}>{item.createDate}</TableCell>
                        </TableRow>
                      ))
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </React.Fragment>
          )
        }
      </Box>

      <Grid container className='foot_list'>
        <Pagination
          activePage={eventListParam.pageNum + 1} // 현재 페이지
          itemsCountPerPage={10} // 한 페이지에 보여줄 아이템 갯수
          totalItemsCount={eventListCount} // 총 아이템 갯수
          pageRangeDisplayed={10} // paginator의 페이지 범위
          prevPageText={"‹"} // "이전"을 나타낼 텍스트
          nextPageText={"›"} // "다음"을 나타낼 텍스트
          onChange={handlePageChange} // 페이지 변경을 핸들링하는 함수
        />
      </Grid>


      {
        <Dialog
          open={open}
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >

          <DialogTitle>
            <Stack direction={'row'}>
              <Typography className="wb_title dialogTitle">이벤트</Typography>
              <Typography sx={{ ml: 'auto', color: '#333', fontSize: 20, cursor: 'pointer', pl: 1 }} onClick={handleClose}>X</Typography>
            </Stack>
          </DialogTitle>
          <Divider />

          <DialogContent sx={{ pb: 3, height: '700px', width: 1000 }}>

            <TableContainer>

              <Box sx={{ border: '1px solid #ccc', borderRadius: 2, position: 'relative' }}>
                <Box sx={{ position: 'absolute', top: -30, left: 0, textAlign: 'center' }}>
                  <BookmarkIcon sx={{ color: eventInfo.recruitment ? '#36b37e' : '#9e9e9e', marginTop: '10px', width: 100, height: 100 }} />
                  <Typography
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      fontSize: 14,
                      fontWeight: 'bold',
                      color: 'white',
                      whiteSpace: 'pre-line',
                    }}
                  >
                    {
                      eventInfo.recruitment ? '모집중' : '모집\n종료'
                    }
                  </Typography>
                </Box>
                <Typography sx={{ fontSize: 18, whiteSpace: 'break-spaces', mt: 3, textAlign: 'center', p: '0px 50px', fontWeight: 700 }}>{eventInfo && eventInfo.title}</Typography>

                <Box className='display_flex justifycontent_center alignitem_center' sx={{ borderBottom: '1px solid #ccc', color: '#555', p: 2, '& p': { margin: '0px 10px', fontSize: '14px !important' } }}>
                  {/* <Typography>모집상태 : {eventInfo.recruitment ? '모집중' : '모집종료'}</Typography>| */}
                  <Typography>작성자 : {eventInfo && eventInfo.author}</Typography>|
                  <Typography>
                    작성일 :
                    {
                      eventInfo.createDate && eventInfo.createDate.indexOf('9999') != -1
                        ? '2020-12-22'
                        : eventInfo.createDate
                    }
                  </Typography>
                </Box>

                <Box className='display_flex alignitem_center' sx={{ p: 2 }}>
                  <Typography sx={{ marginRight: 1, fontSize: 14 }}>첨부파일 : </Typography>
                  {
                    eventInfo.fileName == null
                      ? <Typography sx={{ fontSize: 14, color: '#999' }}>첨부파일이 없습니다.</Typography>
                      : <>
                        <Typography sx={{ cursor: 'pointer', fontSize: 14, '&:hover': { textDecoration: 'underline' } }}>{eventInfo && eventInfo.fileName}</Typography>
                        <Button className="btn_download" variant="contained" size="small" onClick={() => handleFileDownload(eventInfo.id, eventInfo.fileName)}><DownloadIcon sx={{ fontSize: 21 }} /><span style={{ paddingTop: 3 }}>다운로드</span></Button>
                      </>
                  }
                </Box>

                <Box className='' sx={{ borderTop: '1px solid #ccc', color: '#555', p: 2, '& p': { margin: '0px 10px', fontSize: '16px !important' } }}>
                  <Typography sx={{ whiteSpace: 'pre-wrap', p: 5, textAlign: 'left' }}>{eventInfo && eventInfo.content}</Typography>
                </Box>
              </Box>

            </TableContainer>

            {
              eventInfo.recruitment
                ? <Box sx={BtnStyle}>
                  <Button variant="contained" sx={BottomBtnStyle} onClick={handleEventApply}>
                    이벤트 신청하기
                  </Button>
                </Box>
                : ''
            }

          </DialogContent>

          {/* <Divider />

          <DialogActions>
            <Button sx={{background:'#0d6703', color:'#fff', '&:hover':{background: '#074300'}}} onClick={() => navigate('/event/event')}>목록</Button>
          </DialogActions> */}

        </Dialog>
      }


      <Bottom />
    </Container>
  );
}

const img = {
  display: 'flex', p: 0, backgroundImage: `url(${tab04})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
}

const eventBox = {
  mb: 4, maxWidth: '100%', width: '80%', mr: 'auto', ml: 'auto',
  boxSizing: 'border-box',
  '& .MuiAccordion-root:first-of-type': { borderTopLeftRadius: 20, borderTopRightRadius: 20, },
  '& .MuiAccordion-root:last-of-type': { borderBottomLeftRadius: 20, borderBottomRightRadius: 20, },
}

const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  mt: 3,
  boxSizing: 'border-box',
  pb: 3
};

const BottomBtnStyle = {
  width: '20%',
  bgcolor: '#0d6703',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '10px', p: 1.5,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #0d6703',
  ':hover': {
    backgroundColor: '#074300',
    borderColor: '#074300',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#074300',
    borderColor: '#074300',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

export default Event;